import { render, staticRenderFns } from "./agile_plugin.vue?vue&type=template&id=e6521ade"
import script from "./agile_plugin.vue?vue&type=script&lang=js"
export * from "./agile_plugin.vue?vue&type=script&lang=js"
import style0 from "./agile_plugin.vue?vue&type=style&index=0&id=e6521ade&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports